import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DataTransferService {

    
    constructor() { }
    
    get EnvironmentSpecificCustomCategory():string {
        if(sessionStorage.getItem('EnvironmentSpecificCustomCategory')) {
            return sessionStorage.getItem('EnvironmentSpecificCustomCategory');
          } else {
              return;
          }
    }

    set EnvironmentSpecificCustomCategory( custCat: string) {
        if(custCat) {
            sessionStorage.setItem('EnvironmentSpecificCustomCategory', custCat);
          }
    }
    get PortfolioCustomCategory():string {
        if(sessionStorage.getItem('PortfolioCustomCategory')) {
            return sessionStorage.getItem('PortfolioCustomCategory');
          } else {
              return;
          }
    }

    set PortfolioCustomCategory( pcustCat: string) {
        if(pcustCat) {
            sessionStorage.setItem('PortfolioCustomCategory', pcustCat);
          }
    }

    get ShowExternalAccounts():boolean {
        if(sessionStorage.getItem('ShowExternalAccounts') && sessionStorage.getItem('ShowExternalAccounts') === 'true') {
            return true;
          } else if (sessionStorage.getItem('ShowExternalAccounts') && sessionStorage.getItem('ShowExternalAccounts') === 'false') {
              return false;
          } else {
              return false;
          }
    }

    set ShowExternalAccounts( value: boolean) {
        if(value) {
            sessionStorage.setItem('ShowExternalAccounts', 'true');
          } else {
            sessionStorage.setItem('ShowExternalAccounts', 'false');
          }
    }

    get ShowSMASymbol():boolean {
        if(sessionStorage.getItem('ShowSMASymbol') && sessionStorage.getItem('ShowSMASymbol') === 'true') {
            return true;
          } else if (sessionStorage.getItem('ShowSMASymbol') && sessionStorage.getItem('ShowSMASymbol') === 'false') {
              return false;
          } else {
              return false;
          }
    }

    set ShowSMASymbol( value: boolean) {
        if(value) {
            sessionStorage.setItem('ShowSMASymbol', 'true');
          } else {
            sessionStorage.setItem('ShowSMASymbol', 'false');
          }
    }

    get RebalanceObj(){
        return sessionStorage.getItem('rebalanceObj');
    }

   set RebalanceObj(params:any){    
        sessionStorage.setItem('rebalanceObj',JSON.stringify(params));
    }

    get SecurityModelId(){
        return sessionStorage.getItem('securityModelId');
    }

   set SecurityModelId(params:any){    
        sessionStorage.setItem('securityModelId',params);
    }
    get BlendedSecurityModelId(){
        return sessionStorage.getItem('blendedSecurityModelId');
    }

   set BlendedSecurityModelId(params:any){    
        sessionStorage.setItem('blendedSecurityModelId',params);
    }

    get advisorImposedBuyMin () {
        let _advisorImposedBuyMin = sessionStorage.getItem('advisorImposedBuyMin');
        if( _advisorImposedBuyMin) {
            return _advisorImposedBuyMin;
        } else {
            return null;
        }
    }
    set advisorImposedBuyMin (params: any) {
        sessionStorage.setItem('advisorImposedBuyMin',params);
    }

    get advisorImposedSellMin () {
        let _advisorImposedSellMin = sessionStorage.getItem('advisorImposedSellMin');
        if( _advisorImposedSellMin) {
            return _advisorImposedSellMin;
        } else {
            return null;
        }
    }
    set advisorImposedSellMin (params: any) {
        sessionStorage.setItem('advisorImposedSellMin',params);
    }
    get advisorImposedBuyMinPercent () {
        let _advisorImposedBuyMinPercent = sessionStorage.getItem('advisorImposedBuyMinPercent');
        if( _advisorImposedBuyMinPercent) {
            return _advisorImposedBuyMinPercent;
        } else {
            return null;
        }
    }
    set advisorImposedBuyMinPercent (params: any) {
        sessionStorage.setItem('advisorImposedBuyMinPercent',params);
    }
    get advisorImposedSellMinPercent () {
        let _advisorImposedSellMinPercent = sessionStorage.getItem('advisorImposedSellMinPercent');
        if( _advisorImposedSellMinPercent) {
            return _advisorImposedSellMinPercent;
        } else {
            return null;
        }
    }
    set advisorImposedSellMinPercent (params: any) {
        sessionStorage.setItem('advisorImposedSellMinPercent',params);
    }
  
}
